import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['role', 'mailNotify', 'mailNotifyCheckBox']

  connect() {
    this.toggleMailNotify()
  }

  // メール通知が効くのはシステム管理者権限のみ。権限の選択に合わせて入力欄の表示を切り替える。
  // 隠している間はチェックボックスを無効にして、チェックしたまま別の権限で保存されるのを防ぐ。
  toggleMailNotify() {
    if (!this.hasRoleTarget || !this.hasMailNotifyTarget) return

    const enabled = this.roleTarget.value === 'system'

    this.mailNotifyTarget.hidden = !enabled

    if (this.hasMailNotifyCheckBoxTarget) {
      this.mailNotifyCheckBoxTarget.disabled = !enabled
    }
  }
}
